<template>
  <v-card>
    <v-toolbar color="secondary" dark>
      <v-btn icon color="primary" @click.stop="toggleDrawerRight()">
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-toolbar-title>Actvity Stream</v-toolbar-title>
      <v-spacer></v-spacer>
      <ReadActivity @activitymarked="markAll($user.id())"/>
    </v-toolbar>
    <v-list three-line>
      <span v-for="box in boxes" :key="box.id">
        <v-subheader>{{box.description}}</v-subheader>

        <template v-for="(item) in filter(activities, box.id)">
          <v-list-tile :key="item.id" avatar>
            <v-list-tile-avatar color="indigo">
              <img v-if="item.avatar" :src="item.avatar">
              <v-icon dark v-else>person</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content @click="$router.push(item.object_url)">
              <v-list-tile-title v-html="item.actor_name"></v-list-tile-title>
              <v-list-tile-sub-title v-html="item.verb"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <ReadActivity @activitymarked="markActivity(item.id, $user.id())"/>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </span>
    </v-list>
  </v-card>
</template>

<script>
import moment from "moment";
import _ from "lodash";

import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/activities";
import { api as appApi } from "@/store/modules/app";

import ReadActivity from "@/components/snippets/ReadActivity.vue";

export default {
  name: "AuditActivityStream",
  data() {
    return {
      boxes: [
        { id: "today", description: "Today" },
        { id: "yesterday", description: "Yesterday" },
        { id: "lastweek", description: "Last Week" },
        { id: "older", description: "Older" }
      ]
    };
  },
  components: {
    ReadActivity
  },
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.filteredActivities,
      api.getters.loadedActivities
    ]),
    activities() {
      return this.loadedActivities;
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.actions.readActivity]),
    ...mapActions(appApi.namespace, [appApi.actions.toggleDrawerRight]),
    markActivity(activity_id, user_id) {
      console.log("Acti", activity_id, user_id);
      let payload = { activity_id: activity_id, user_id: user_id, data: true };
      this.readActivity(payload);
    },
    markAll(user_id) {
      for (let key in this.activities) {
        let payload = {
          activity_id: this.activities[key].id,
          user_id: user_id,
          data: true
        };
        this.readActivity(payload);
      }
    },
    filter(items, query) {
      return _.filter(items, function(item) {
        let now = moment();
        let today = now.clone().startOf("day");
        let yesterday = now
          .clone()
          .subtract(1, "days")
          .startOf("day");
        let lastweek = now
          .clone()
          .subtract(7, "days")
          .startOf("day");
        let momentDate = moment(item.timestamp);

        if (query === "today") {
          if (momentDate.isSame(today, "d")) {
            return item;
          }
        } else if (query === "yesterday") {
          if (momentDate.isSame(yesterday, "d")) {
            return item;
          }
        } else if (query === "lastweek") {
          if (
            momentDate.isAfter(lastweek, "d") &&
            momentDate.isBefore(yesterday, "d")
          ) {
            return item;
          }
        } else if (query === "older") {
          if (momentDate.isBefore(lastweek, "d")) {
            return item;
          }
        } else {
          return item;
        }
      });
    }
  }
};
</script>
